import PropTypes from "prop-types";

export default {
	id: PropTypes.string,
	data: PropTypes.object,
	src: PropTypes.string,
	delay: PropTypes.number,
};
